import React from 'react';

export interface ParentGateProps {
  open: boolean;
  onClose: () => void;
  /** Placeholder — real adult gate arrives later. Never show payment to the child. */
  title?: string;
}

/**
 * Placeholder parent gate. Pluss locks open this, never a payment screen.
 */
export const ParentGate: React.FC<ParentGateProps> = ({
  open,
  onClose,
  title = 'For voksne',
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      data-name="parent-gate"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="font-display text-2xl font-bold text-gray-800 mb-2">{title}</h2>
        <p className="font-body text-gray-600 mb-6">
          Dette er en plassholder for foreldreporten. Betalingsskjerm kommer aldri direkte til barnet.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="min-h-[96px] w-full rounded-2xl bg-[#669bbc] font-display text-xl font-bold text-white"
        >
          Lukk
        </button>
      </div>
    </div>
  );
};

export default ParentGate;
